'use client';

import { CopyIcon } from '@insta-club/components';
import { ChatBotMessage } from '@insta-club/models';
import { TypedEffect } from '@insta-club/ui';
import { copyToClipboard } from '@insta-club/utilities';

interface Props {
    message: ChatBotMessage;
    onEffectBegin?: () => void;
    onEffectComplete?: () => void;
}

const SystemChatBubble: React.FC<Props> = ({ message, onEffectBegin, onEffectComplete }) => {
    return (
        <div className='flex max-w-xs flex-col self-end'>
            <div className='self-end rounded-t-2xl rounded-br-2xl bg-gray-100 px-4 py-2'>
                {!message.pre_message && message.typed_effect ? (
                    <TypedEffect
                        showCursor={false}
                        text={message.content}
                        onBegin={onEffectBegin}
                        onComplete={onEffectComplete}
                        className='text-sm leading-loose text-gray-600'
                    />
                ) : (
                    <div
                        className='text-sm leading-loose text-gray-600'
                        dangerouslySetInnerHTML={{
                            __html: message.content
                        }}
                    />
                )}
            </div>
            {!message.pre_message && !message.typed_effect ? (
                <div
                    onClick={() => copyToClipboard(message.content)}
                    className='mt-2 flex cursor-pointer items-center justify-center gap-1 self-end rounded-full bg-gray-100 p-2 text-gray-600'
                >
                    <CopyIcon width={14} height={14} />
                </div>
            ) : null}
        </div>
    );
};

export default SystemChatBubble;

